import styled from 'styled-components';
import { sectionContainerCss } from '../styles';
export const SocialSection = styled.div `
    ${sectionContainerCss};

    > div {
        display: flex;
        flex-wrap: wrap;

        margin: -8px;
        justify-content: ${(props) => props.theme.align.toLowerCase()};

        > * {
            margin: 8px;
        }
    }
`;
export const SocialIcon = styled.div ``;
